<div>
  <img id="backgroundImage">
  <div class="content">
    <div id="filterSearch">
      <mat-accordion>
        <mat-expansion-panel [expanded]="!isMobile()" style="border-radius: 4px">
          <mat-expansion-panel-header>
            <mat-panel-title class="card-title-text">
              Search Fields
            </mat-panel-title>
            <mat-panel-description class="card-title-text">
              Refine Your Search
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="filter filter-box">
            @if (loading) {
              <mat-progress-bar style="height: 5px; width: 100%" mode="indeterminate"></mat-progress-bar>
            }

            <div class="flex-row">
              <mat-form-field appearance="outline" class="flex-1 margin-right-10">
                <mat-label>Service Type</mat-label>

                <mat-select [(ngModel)]="selectedServiceType" [ngModelOptions]="{ standalone: true }">
                  @for (serviceType of serviceTypes; track serviceType) {
                    <mat-option [value]="serviceType">
                      {{ serviceType.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="flex-1 margin-right-10">
                <mat-label>Business Name</mat-label>

                <input type="text" placeholder="Filter by Business..." aria-label="Business Name" matInput [formControl]="businessNameFormControl" autocomplete="off" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="flex-1 margin-right-10">
                <mat-label>Order By</mat-label>

                <mat-select [(ngModel)]="selectedOrderBy" [ngModelOptions]="{ standalone: true }">
                  @for (orderByValue of orderByValues; track orderByValue) {
                    <mat-option [value]="orderByValue.value">
                      {{ orderByValue.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="flex-1 margin-right-10">
                <mat-label>State of Provider</mat-label>

                <mat-select [(ngModel)]="selectedState" [ngModelOptions]="{ standalone: true }">
                  @for (state of states; track state) {
                    <mat-option [value]="state">
                      {{ state }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <div>
                <div>
                  <mat-checkbox color="primary" [formControl]="homeCareAvailabilityFormControl">
                    <div class="mt-2">Home Care</div>
                  </mat-checkbox>
                </div>

                <div>
                  <mat-checkbox color="primary" [formControl]="virtualAvailabilityFormControl">
                    <div class="mt-2">Virtual Care</div>
                  </mat-checkbox>
                </div>

                <div>
                  <mat-checkbox color="primary" [formControl]="inOfficeAvailabilityFormControl">
                    <div class="mt-2">In Office Care</div>
                  </mat-checkbox>
                </div>

                <hr>

                  <div>
                    <mat-checkbox color="primary" [formControl]="hsaApprovedFormControl"><div style="padding-top: 8px;">HSA Approved</div></mat-checkbox>
                  </div>
                </div>
              </div>

              <div class="ml-2 searchButtonContainer">
                <button style="border-radius: 4px;" color="success" mat-raised-button (click)="searchEnter()">
                  Search
                </button>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        @if (servicePlans.length == 0 && hasSearched) {
          <span class="ml-2 no-results">No Services Plans Matching Search</span>
        }
      </div>

      <div class="result-box flex-row">
        @for (servicePlan of servicePlans; track servicePlan) {
          <div style="margin:auto;" class="flex-1 card-results">
            <mat-card class="flex-1 card">
              @if (servicePlan.serviceProviderModel.businessName == null) {
                <div class="card-avatar-header">
                    <img mat-card-avatar class="avatar" [src]="servicePlan.imageData">
                    <mat-card-title class="grey-font mb-4">{{ servicePlan.serviceProviderModel.firstName + " " + servicePlan.serviceProviderModel.lastName }}</mat-card-title>
                    <mat-card-subtitle><br/></mat-card-subtitle>
                </div>
              }
              @if (servicePlan.serviceProviderModel.businessName != null) {
                <div class="card-avatar-header">
                  <img mat-card-avatar class="avatar" [src]="servicePlan.imageData">
                  <mat-card-title class="grey-font mb-4">{{ servicePlan.serviceProviderModel.businessName }}</mat-card-title>
                </div>
              }
              <mat-card-content class="cant-grow grey-font pb-3 card-text">
                Description:
                <span>
                  {{ servicePlan.description }}
                </span>
                <br/>
                <br/>Service Type:
                <span>
                  {{ servicePlan.serviceTypeModel.name }}
                </span>
                <br/> Provider Location:
                <span>
                  {{ servicePlan.serviceProviderModel.state.toUpperCase() }}
                </span>
                <br/> Rate:
                <span> ${{ servicePlan.rate.toFixed(2) }} </span>
                <br/> Appointment Type: {{ servicePlan.appointmentType }}<br />
              </mat-card-content>
              <mat-card-actions style="justify-content: center;">
                <button style="border-radius: 4px;" color="success" mat-raised-button (click)="routeToProductView(servicePlan)">
                  Buy
                </button>
              </mat-card-actions>
            </mat-card>
          </div>
        }
      </div>
    </div>
    <footer class="mb-5">
      <button mat-raised-button class="mb-5 mt-3" [hidden]="!moreServicePlansToLoad" (click)="loadMoreServicePlans()" color="primary">Load More</button>
    </footer>
  </div>